import { getAUsersRoles, getAccessToken } from "./states";

export const services = {
  getAUsersRoles,
  getAccessToken,
};
